export function getDataByIdentifier (payload, reasonCode = '') {
  switch (payload.identifier) {
    case 'shipments':
      return {
        'shipping_items': [{
          'item_id': `${payload.price.item_id}`,
          'price_adjustments': [
            {
              'custom': true,
              'manual': true,
              'reason_code': `${reasonCode}`,
              'promotion_id': `${payload.price.promotion_id}`,
              'applied_discount': {
                'amount': payload.price.applied_discount.amount,
                'type': `${payload.price.applied_discount.type}`
              }
            }
          ]
        }]
      }
    case 'products':
      return {
        'product_items': [{
          'item_id': `${payload.price.item_id}`,
          'price_adjustments': [
            {
              'custom': true,
              'manual': true,
              'reason_code': `${reasonCode}`,
              'promotion_id': `${payload.price.promotion_id}`,
              'applied_discount': {
                'amount': payload.price.applied_discount.amount,
                'type': `${payload.price.applied_discount.type}`
              }
            }
          ]
        }]
      }
    case 'order':
      return {
        'order_price_adjustments': [{
          'custom': true,
          'manual': true,
          'reason_code': `${reasonCode}`,
          'promotion_id': `${payload.price.promotion_id}`,
          'applied_discount': {
            'amount': payload.price.applied_discount.amount,
            'type': `${payload.price.applied_discount.type}`
          }
        }]
      }
  }
}
